export default {
  'mediaCategories.title': 'Gestionar Categorías de Media',
  'mediaCategories.form.color': 'Color',
};
